import styled from "styled-components";

export const HeaderShell = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(6px);
  border-bottom: 1px solid #e2e8f0;
`;

export const HeaderInner = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Nav = styled.nav`
  display: none;
  gap: 24px;
  font-size: 16px;
  font-weight: 600;
  @media (min-width: 768px) {
    display: inline-flex;
  }
  a:hover {
    color: var(--green, #24ae7c);
  }
`;

export const ContactLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #24ae7c;
  @media (min-width: 768px) {
    display: none;
  }
`;
